module.exports = __webpack_public_path__ + "img/5.6c51a0c9.png";